import { memo, useState } from 'react'
import { IconButton } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import type { CollectionObjectsGroup } from '@/objects/services/CollectionObjectsService.ts'
import type { PropertyColumn } from 'objects/collection-view/grid/PropertyColumn.tsx'
import { GridRow } from 'objects/collection-view/grid/GridRow.tsx'

interface CollectionGroupProps {
  group: CollectionObjectsGroup
  orderedColumns: PropertyColumn[]
  gridTemplateColumns: string
  hideHeader?: boolean
}

export const CollectionGroup = memo(CollectionGroupRaw)

function CollectionGroupRaw({
  group,
  orderedColumns,
  gridTemplateColumns,
  hideHeader,
}: CollectionGroupProps) {
  const [expanded, setExpanded] = useState(true)
  const isExpanded = hideHeader || expanded

  return (
    <div>
      {!hideHeader && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            borderBottom: '1px solid var(--mui-palette-divider, #e0e0e0)',
            background: 'var(--mui-palette-background-default, #fafafa)',
            position: 'sticky',
            left: 0,
          }}
        >
          <IconButton size="small" onClick={() => setExpanded((v) => !v)}>
            <ChevronRightIcon
              sx={{
                fontSize: 18,
                transition: 'transform 0.15s',
                transform: expanded ? 'rotate(90deg)' : 'none',
              }}
            />
          </IconButton>
          <span style={{ fontSize: 13, fontWeight: 600, marginLeft: 4 }}>
            {group.groupByOption?.value ?? 'No value'}
          </span>
          <span style={{ fontSize: 12, color: 'var(--mui-palette-text-secondary)', marginLeft: 8 }}>
            {group.objects.length}
          </span>
        </div>
      )}

      {isExpanded && (
        <div style={{ display: 'grid', gridTemplateColumns }}>
          {group.objects.map((obj) => (
            <GridRow key={obj.id} obj={obj} orderedColumns={orderedColumns} />
          ))}
        </div>
      )}
    </div>
  )
}
